import { ActionType, PermissionTypes, ListType, ViewType } from "./Enums";
import GetAvdelningById from "../utils/UserFunctions/GetAvdelningById";
//import GetHasRedigera from "../utils/UserFunctions/GetHasRedigera";
import GetUser from "../utils/UserFunctions/GetUser";
import * as _ from "lodash";
import moment from "moment";

var functions = {
  formatPostnr: function (value) {
    if (!value) return "";
    if (value.toString().length !== 5) return value;
    return value.toString().slice(0, 3) + " " + value.toString().slice(3);
  },
  hasFlag: function (permissions, flag) {
    if ((permissions & flag) === flag) return true;
    return false;
  },
  getStringsFromEnum: function (em, opt, value) {
    const arr = [];
    for (var k in em) {
      if (this.hasFlag(value, em[k])) {
        arr.push({ property: k.toString(), description: null, optional: opt });
      }
    }
    return arr;
  },
  addStringsFromEnum: function (em, value, arr) {
    for (var k in em) {
      if (this.hasFlag(value, em[k])) {
        arr.push({
          property: k.toString(),
          description: null,
          optional: false,
        });
      }
    }
    return arr;
  },
  hasFlagFromStatus: function (
    permissions,
    status,
    useKontrollera,
    skipExtraKontroll = false,
    allowedit = false
  ) {
    switch (status) {
      case 0:
        return (
          (permissions & PermissionTypes.Godkanna) === PermissionTypes.Godkanna
        );
      case 1:
      case 2:
      case 3:
        return (
          (permissions & PermissionTypes.Starta) === PermissionTypes.Starta
        );
      case 4:
        if (
          allowedit &&
          (permissions & PermissionTypes.Godkanna) === PermissionTypes.Godkanna
        )
          return true;
        return (
          (permissions & PermissionTypes.RegistreraSignera) ===
            PermissionTypes.RegistreraSignera ||
          (permissions & PermissionTypes.Skapa) === PermissionTypes.Skapa
        );
      case 5:
        if (useKontrollera && !skipExtraKontroll) {
          return (
            (permissions & PermissionTypes.Kontrollera) ===
            PermissionTypes.Kontrollera
          );
        } else {
          return (
            (permissions & PermissionTypes.Slutrapportera) ===
            PermissionTypes.Slutrapportera
          );
        }

      case 6:
        return (
          (permissions & PermissionTypes.Slutrapportera) ===
          PermissionTypes.Slutrapportera
        );
      default:
        return false;
    }
  },

  addRemoved: function (list, entity) {
    if (!list) return list;
    if (!entity || !entity.id) return list;

    if (list.find((x) => x.id === entity.id)) return list;
    const newlist = [];
    newlist.push(entity);
    list.forEach((x) => newlist.push(x));
    return newlist;
  },
  getUrlFromView: function (view, listtype) {
    let addon = "";
    if (listtype) {
      switch (listtype) {
        case ListType.Samverkanspart:
          addon = "samverkansparts/";
          break;
        case ListType.Avdelning:
          addon = "avdelnings/";
          break;
        default:
          break;
      }
    }
    switch (view) {
      case ViewType.VisaGodkända:
        return "/" + addon + "godkanda";
      case ViewType.VisaSlutförda:
        return "/" + addon + "slutforda";
      case ViewType.VisaPågående:
        return "/" + addon + "pagaende";
      case ViewType.VisaArkiverade:
        return "/" + addon + "arkiverade";
      case ViewType.Godkända:
        return "/" + addon + "komplettera-godkanda";
      case ViewType.AttSkickaTillStartare:
        return "/" + addon + "ej-tilldelade";
      case ViewType.InskickadeSomSkaGodkännas:
        return "/" + addon + "ej-godkanda";
      case ViewType.NekadeSomSkaKompletteras:
        return "/" + addon + "nekade";
      case ViewType.EjInskickade:
        return "/" + addon + "komplettera-ej-behandlade-arrangemang";
      case ViewType.AttGodkänna:
        return "/" + addon + "godkanna";
      case ViewType.AttStarta:
        return "/" + addon + "starta";
      case ViewType.AttRegistreraNärvaro:
        return "/" + addon + "registrera-narvaro-signera";
      case ViewType.AttKontrollera:
        return "/" + addon + "kontrollera";
      case ViewType.AttSlutrapportera:
        return "/" + addon + "slutrapportera";
      case ViewType.AttSkapa:
        return "/" + addon + "skapa";
      case ViewType.RedigeraStartade:
        return "/" + addon + "editpagaende";
      default:
        return "skapa";
    }
  },
  getLabelFromView: function (view, listtype) {
    let addon = "";
    if (listtype) {
      switch (listtype) {
        case ListType.Samverkanspart:
          addon = "organisationers ";
          break;
        case ListType.Avdelning:
          addon = "avdelningens ";
          break;
        default:
          break;
      }
    }
    switch (view) {
      case ViewType.VisaGodkända:
        return addon + "godkända";
      case ViewType.VisaSlutförda:
        return addon + "slutförda";
      case ViewType.VisaPågående:
        return addon + "pågående";
      case ViewType.VisaArkiverade:
        return addon + "arkiverade";
      case ViewType.Godkända:
        return addon + "godkända";
      case ViewType.AttSkickaTillStartare:
        return addon + "att skicka till startare";
      case ViewType.InskickadeSomSkaGodkännas:
        return addon + "inskickade som ska godkännas";
      case ViewType.NekadeSomSkaKompletteras:
        return addon + "nekade som ska kompletteras";
      case ViewType.EjInskickade:
        return addon + "ej inskickade";
      case ViewType.AttGodkänna:
        return addon + "att godkänna";
      case ViewType.AttStarta:
        return addon + "att starta";
      case ViewType.AttRegistreraNärvaro:
        return addon + "Registrera närvaro";
      case ViewType.AttKontrollera:
        return addon + "att kontrollera närvaro";
      case ViewType.AttSlutrapportera:
        return addon + "att slutrapportera";
      case ViewType.AttSkapa:
        return "skapa arrangemang";
      case ViewType.RedigeraStartade:
        return addon + "redigera pågående";
      default:
        return "";
    }
  },

  getMeddelandeUrlSegmentFromStatus: function (status) {
    switch (status) {
      case -1:
        return "nekade";
      case 0:
        return "godkanna";
      case 1:
      case 2:
      case 3:
        return "starta";
      case 4:
        return "registrera-narvaro-signera";
      case 5:
        return "kontrollera";
      case 6:
        return "slutrapportera";
      default:
        return "";
    }
  },
  getLastUrlSegmentFromStatus: function (status, sendTo) {
    switch (status) {
      case -1:
        return "skickat";
      case 0:
        return sendTo ? "vidarebefodrat" : "godkant";
      case 1:
      case 2:
      case 3:
        return sendTo ? "vidarebefodrat" : "startat";
      case 4:
        return "signerat";
      case 5:
        return "kontrollerat";
      case 6:
        return "slutrapporterat";
      default:
        return "";
    }
  },
  isKultur: function (arr) {
    return (
      arr?.verksamhetsform?.id === 2 ||
      arr?.verksamhetsform === "2" ||
      (arr?.verksamhetsform?.id === 6 && arr?.arrangemangstyp?.id === 6)
    );
  },
  isAfv: function (arr) {
    return (
      arr &&
      arr.verksamhetsform &&
      arr.verksamhetsform.id &&
      arr.verksamhetsform.id === 3
    );
  },
  isSuportedAVF: function (arr) {
    return (
      arr.verksamhetsform &&
      arr.verksamhetsform.id &&
      arr.arrangemangstyp.id &&
      ((arr.arrangemangstyp.id === 1 && arr.verksamhetsform.id === 1) ||
        (arr.arrangemangstyp.id === 1 && arr.verksamhetsform.id === 2) ||
        (arr.arrangemangstyp.id === 1 && arr.verksamhetsform.id === 3) ||
        (arr.arrangemangstyp.id === 2 && arr.verksamhetsform.id === 1) ||
        (arr.arrangemangstyp.id === 2 && arr.verksamhetsform.id === 3))
    );
  },
  isSvenskaDag1: function (arr) {
    return (
      arr &&
      arr.arrangemangstyp &&
      arr.arrangemangstyp.id &&
      arr.arrangemangstyp.id == 2
    );
  },
  isVardagssvenska: function (arr) {
    return (
      arr &&
      arr.arrangemangstyp &&
      arr.arrangemangstyp.id &&
      arr.arrangemangstyp.id == 3
    );
  },

  isLandstingsfinansierad: function (arr) {
    return (
      arr &&
      arr.arrangemangstyp &&
      arr.arrangemangstyp.id &&
      arr.arrangemangstyp.id == 5
    );
  },

  getHasPermissionForStatusFour: function (data) {
    if (!data) return "Inget arrangemang hittades!";

    if (data.errors && data.errors.length > 0) return data.errors.join();

    if (!data.elista)
      return "Arrangemanget tillåter inte digital registering av närvaro!";
    if (data.status !== 4)
      return (
        "Arrangemanget " +
        (data.status > 4 ? "är signerat!" : "har inte startat ännu!")
      );
    if (!this.hasPermissionToHandleArr(data))
      return "Du saknar rättigheter för att visa detta arrangemang!";

    return null;
  },
  getHasPermissionForStatusFourMulti: function (datas) {
    let noPerm = "";
    for (const data of datas) {
      const perm = this.getHasPermissionForStatusFour(data);

      if (perm) {
        noPerm = perm;
        break;
      }
    }

    noPerm = noPerm.replace("Arrangemanget", "Arrangemangen");
    noPerm = noPerm.replace("signerat", "signerade");
    noPerm = noPerm.replace("detta", "valda");

    return noPerm;
  },

  hasPermissionToHandleArr: function (arr, skipExtraKontroll = false) {
    if (!arr) return false;
    if (arr.errors && arr.errors.length > 0) return false;
    const avd = GetAvdelningById(arr.avdelning.id);
    //const userId = GetUser().id;
    const allowEdit =
      avd.allowEditOnStarted && window.location.href.includes("editpagaende");
    const hasPermission = this.hasFlagFromStatus(
      avd.permission,
      arr.status,
      avd.useKontrollera,
      skipExtraKontroll,
      allowEdit
    );

    switch (arr.status) {
      case -1:
        return true;
      case 0:
        return true;
      case 1:
      case 2:
      case 3:
        return true;
      case 4:
        if (!hasPermission) return false;
        /*  if (this.isKultur(arr)) {
           if (
            !avd.allowEditOnStarted &&
            (!arr.kontaktperson || arr.kontaktperson.id !== userId)
          )
            return false;
        } else {
          return true;
        }  */
        return true;
      case 5:
        if (!hasPermission) return false;
        return true;
      case 6:
        if (!hasPermission) return false;
        return true;
      default:
        return true;
    }
  },

  getArrNrNameSamv: function (data, arr) {
    //Kolla om det är bunt av arrangemang
    if (_.isArray(data)) {
      let result = [];
      data.map((item) => {
        result.push(
          item?.arrNr +
            " - " +
            item?.name +
            " " +
            (item?.samverkanspart ? "(" + item?.samverkanspart + ")" : "")
        );
      });
      return arr ? result : result.join("\n");
    }
    const samvName =
      data && data.huvudsamverkanspart && data.huvudsamverkanspart.id
        ? "(" + data.huvudsamverkanspart.namn + ")"
        : "";
    return (data.arrNr + " - " + data.namn + " " + samvName).toUpperCase();
  },
  getActionTypeFromStatus: function (status, reject) {
    switch (status) {
      case -1:
        return ActionType.Skicka;
      case 0:
        return reject ? ActionType.Avsla : ActionType.Godkanna;

      case 1:
      case 2:
        return reject ? ActionType.AvslaGodkanna : 0;
      case 3:
        return reject ? ActionType.AvslaGodkanna : ActionType.Starta;
      case 4:
        return ActionType.Signera;
      case 5:
        return ActionType.Kontrollera;
      case 6:
        return ActionType.Slutrapportera;
      default:
        return 0;
    }
  },

  getAvdelningFilterElements: function (view) {
    return GetUser()
      .avdelnings.filter((x) => (x.views.find((x) => x === view) ? x : null))
      .filter((x) => x)
      .map((x) => ({ id: x.id, namn: x.namn }));
  },
  getArransvarigFilterElements: function (id) {
    if (!id) return [];
    var ansvarigs = GetAvdelningById(id).arransvarigs;
    if (!ansvarigs || ansvarigs.length === 0) return [];

    return ansvarigs.map((x) => ({ id: x.id, namn: x.namn }));
  },
  getTodoFilterElements: function () {
    return [
      { id: 4, namn: "Registrera närvaro" },
      { id: -1, namn: "Ej inskickade" },
      { id: -3, namn: "Inskickade som ska godkännas" },
      { id: -2, namn: "Nekade som ska kompletteras" },
      { id: -5, namn: "Godkända" },
    ];
  },
  getNarvaroFilterElements: function () {
    return [
      { id: 1, namn: "Alla närvarolistor" },
      { id: 2, namn: "Klar att signera" },
      { id: 3, namn: "Registrera Närvaro" },
      { id: 4, namn: "Startade" },
      { id: 5, namn: "Startade utan närvaro" },
    ];
  },
  getArrtypFilterElements: function () {
    return [
      { id: 1, namn: "Studiecirkel" },
      { id: 2, namn: "Kulturprogram" },
      { id: 4, namn: "Annan folkbildningsverksamhet" },
      /*  { id: 8, namn: "Svenska från dag 1, studiecirkel" },
      { id: 16, namn: "Svenska från dag 1, annan folkbildningsverksamhet" }, */
    ];
  },
  getSortOrderElements: function () {
    return [
      { id: 0, namn: "Stigande" },
      { id: 1, namn: "Fallande" },
    ];
  },
  getSortElements: function (view) {
    switch (view) {
      case ViewType.Kontrollera: //Kontrollera
        return [
          { id: 17, namn: "Arrangemangsnummer" },
          { id: 1, namn: "Arrangemangets namn" },
          { id: 3, namn: "Samverkanspart" },
          { id: 5, namn: "Huvudledare" },
          { id: 7, namn: "Typ av arrangemang" },
          { id: 15, namn: "Slutdatum" },
        ];
      default:
        return [
          { id: 0, namn: "Senast skapad" },
          { id: 1, namn: "Arrangemangets namn" },
          { id: 3, namn: "Samverkanspart" },
          { id: 5, namn: "Huvudledare" },
          { id: 7, namn: "Typ av arrangemang" },
          { id: 9, namn: "Startdatum" },
          { id: 11, namn: "Status" },
          {
            id: 13,
            namn:
              view === ViewType.AttRegistreraNärvaro
                ? "Kontaktperson"
                : "Arransvarig",
          },
        ];
    }
  },
  getErrorIfNotEfterRegistreringStartklar: function (arrangemang) {
    var startdate = arrangemang.startdatum;
    if (!startdate) return null;
    if (arrangemang.status >= 3) return null;
    return this.getErrorIfNotEfterRegistrering(arrangemang);
  },
  getErrorIfNotEfterRegistrering: function (arrangemang) {
    var startdate = arrangemang.startdatum;
    if (!startdate) return null;
    if (arrangemang.status >= 4) return null;

    var a = moment(startdate);
    var b = moment();
    var diff = b.diff(a, "days");

    return (
      //!GetHasRedigera(arrangemang.avdelning.id) &&
      diff > arrangemang.arrangemangstyp.maxDagarStartArrIntern
    );
    /* return (
            this.isKultur(arrangemang) &&
            !GetHasRedigera(arrangemang.avdelning.id) &&
            !GetUser().forbund.tillatEfterregistering &&
            this.getDate(new Date(arrangemang.startdatum)) < this.getDate(new Date())
        ); */
  },
  getDate: function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  },
  getDiffDays: function (strdate, arrangemang, narvaroRegistrering) {
    var a = moment(strdate);
    var b = moment();
    var diff = b.diff(a, "days");

    var maxdays = narvaroRegistrering
      ? arrangemang.arrangemangstyp.maxDagarStartArrLedare
      : arrangemang.arrangemangstyp.maxDagarStartArrIntern;
    if (diff > maxdays) {
      return !narvaroRegistrering
        ? "Efterregistrering är bara tillåten " +
            maxdays +
            " dagar bakåt i tiden. Du har angivit ett datum " +
            diff +
            " dagar bakåt."
        : "Du kan ändra sammankomstens uppgifter men inte datumet, eftersom efterregistrering endast är tillåten " +
            maxdays +
            " dagar bakåt i tiden.";
    }
    return null;
  },
  getDistansforms: function () {
    return [
      { id: 0, namn: "Ej Distans" },
      { id: 1, namn: "Distans" },
      { id: 2, namn: "Blandform" },
    ];
  },
};
export default functions;
